import {
    type LoaderFunction,
    createBrowserRouter,
    redirect,
} from 'react-router-dom';

import { getAbsoluteRoute } from '../util';

import authRoutes from './auth';
import maintenanceRoot from './MaintenanceRoot';
import root from './Root';

// @TODO: remove these. This shouldn't be done in a random PR, but we probably don't need these anymore. The old URLs haven't been used in nearly 2 years.
const redirects = {
    '/pharmacy/inNetwork': getAbsoluteRoute('pharmacy.inNetwork'),
    '/startsaving': getAbsoluteRoute('startSaving'),
};

// @see https://reactrouter.com/start/data/routing#splats
const splatRedirects = {
    '/order': '/orders',
};

export const router = createBrowserRouter([
    ...authRoutes,
    root,
    ...Object.entries(redirects).map(([oldPath, newPath]) => ({
        path: oldPath,
        loader: () => redirect(newPath),
    })),
    ...Object.entries(splatRedirects).map(([oldPath, newPath]) => ({
        path: `/${oldPath}/*`,
        loader: (({ params }) =>
            redirect(`${newPath}/${params['*']}`)) as LoaderFunction,
    })),
]);

export const maintenanceRouter = createBrowserRouter([
    ...authRoutes,
    maintenanceRoot,
    ...Object.entries(redirects).map(([oldPath, newPath]) => ({
        path: oldPath,
        loader: () => redirect(newPath),
    })),
    ...Object.entries(splatRedirects).map(([oldPath, newPath]) => ({
        path: `/${oldPath}/*`,
        loader: (({ params }) =>
            redirect(`${newPath}/${params['*']}`)) as LoaderFunction,
    })),
]);
